import React from 'react';
import { BoxIcon } from 'lucide-react';
interface QuickReply {
  label: string;
  icon?: BoxIcon;
}
interface CopilotQuickRepliesProps {
  options: QuickReply[];
  onSelect: (label: string) => void;
  disabled?: boolean;
}
export function CopilotQuickReplies({
  options,
  onSelect,
  disabled
}: CopilotQuickRepliesProps) {
  return <div className="flex flex-wrap gap-2 mt-1 animate-slide-in" data-id="element-55">
      {options.map(option => {
      const Icon = option.icon;
      return <button key={option.label} onClick={() => onSelect(option.label)} disabled={disabled} className="inline-flex items-center gap-2 border border-border rounded-full px-4 py-2 text-sm font-medium text-foreground bg-card hover:bg-muted/50 hover:border-primary/50 transition-all focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed shadow-sm" data-id="element-56">
            {Icon && <Icon className="w-4 h-4 text-muted-foreground" data-id="element-57" />}
            {option.label}
          </button>;
    })}
    </div>;
}